<template lang="pug">
  div
    Row(type="flex" justify="space-between")
        Col(:lg="2" :md="4" :sm="24" v-if="$store.getters.getDashboardConfig.dashboardWithSearchBtn")
            SearchChartBtn(searchBtnText="GO" searchBtnIcon="md-search")
        Col(:lg="22" :md="20" :sm="24")
            components(
                :is="dashboardQueryFilterStyle[$store.getters.getDashboardConfig.dashboardQueryFilter]"
                :isWithGroupName="true"
                :isWithEdgeName="$store.getters.isAdmin"
                :customTimeRangeOptions="timeRangeOptions"
                :dateRangeLimit="dateRangeLimit"
                )
                
    Row
        Col(:lg="12" :md="24")
            Card.dashBoardCard
                LineChartWrapper(
                  :chartType="'DomainLineChart'"
                  :chartTitle="$t('dashboard.DomainTrendingTitleText')"
                  :withCard="false"
                  :linePointRadius="[4]"
                  :linePointHoverRadius="[8]"
                  :linePointBackgroundColor="['white']"
                  :linePointBorderWidth="[3]"
                  :lineBorderColors="colorScheme.colorSets.border"
                  :useBackendDatasetLabel="true"
                  :legendPosition="'right'"
                  :legendAlign="'start'"
                  :isPointStyle="$store.getters.getChartConfig.legendPointStyle")
        Col(:lg="12" :md="24")
            Card.dashBoardCard
                LineChartWrapper(
                  :chartType="'SourceIpLineChart'"
                  :chartTitle="$t('dashboard.SourceIpTrendingTitleText')"
                  :withCard="false"
                  :linePointRadius="[4]"
                  :linePointHoverRadius="[8]"
                  :linePointBackgroundColor="['white']"
                  :linePointBorderWidth="[3]"
                  :lineBorderColors="colorScheme.colorSets.border"
                  :useBackendDatasetLabel="true"
                  :legendPosition="'right'"
                  :legendAlign="'start'"
                  :isPointStyle="$store.getters.getChartConfig.legendPointStyle")
    Row
        Col(:lg="12" :md="24")
            Card.dashBoardCard
                LineChartWrapper(
                  :chartType="'httpStatusCodeLineChart'"
                  :chartTitle="$t('dashboard.HttpStatusCodeTrendingTitleText')"
                  :withCard="false"
                  :linePointRadius="[4]"
                  :linePointHoverRadius="[8]"
                  :linePointBackgroundColor="['white']"
                  :linePointBorderWidth="[3]"
                  :lineBorderColors="colorScheme.colorSets.border"
                  :useBackendDatasetLabel="true"
                  :legendPosition="'right'"
                  :legendAlign="'start'"
                  :isPointStyle="$store.getters.getChartConfig.legendPointStyle")
        Col(:lg="12" :md="24")
            Card.dashBoardCard
                LineChartWrapper(
                  :chartType="'StatusCodeResponseTimeLineChart'"
                  :chartTitle="$t('dashboard.ResponseTimeStatusCodeTitleText')"
                  :numeralFormat="'0.00a'"
                  :withCard="false"
                  :linePointRadius="[4]"
                  :linePointHoverRadius="[8]"
                  :linePointBackgroundColor="['white']"
                  :linePointBorderWidth="[3]"
                  :lineBorderColors="colorScheme.colorSets.border"
                  :useBackendDatasetLabel="true"
                  :legendPosition="'right'"
                  :legendAlign="'start'"
                  :isPointStyle="$store.getters.getChartConfig.legendPointStyle")
</template>
<script>
import bus from "@/libs/bus.js";
import { getTimeRangeOptions } from "@/libs/utils";
import enumList from "@/libs/enumList";

import DashboardQueryFilterV2 from "@/components/DashboardQueryFilterV2";
import DashboardQueryFilterV3 from "@/components/DashboardQueryFilterV3";

import LineChartWrapper from "@/components/dashboard/LineChartWrapper";
import BarChartWrapper from "@/components/dashboard/BarChartWrapper";
import SingleNumWrapper from "@/components/dashboard/SingleNumWrapper";
import PieChartWrapper from "@/components/dashboard/PieChartWrapper";

import colorScheme from "@/data/colorScheme";

export default {
    name: "RequestSummary",
    components: {
        LineChartWrapper,
        BarChartWrapper,
        SingleNumWrapper,
        PieChartWrapper,
        SearchChartBtn: () => import("@/components/SearchChartBtn")
    },
    data() {
        return {
            colorScheme: colorScheme,
            chartHeight: 340,
            direction: "horizontal",
            dashboardQueryFilterStyle: {
                V2: DashboardQueryFilterV2,
                V3: DashboardQueryFilterV3,
            },
            timeRangeOptions: [],
            dateRangeLimit: 90,
        };
    },
    methods: {
        async loadTimeSettings() {
            const { dateRangeLimit, timeRangeOptions } = await getTimeRangeOptions({
                dateRangeKey: enumList.dashboardTimeRangeType.REQUEST_SUMMARY,
            });
            this.dateRangeLimit = dateRangeLimit;
            this.timeRangeOptions = timeRangeOptions;
        },
    },
    mounted() {},
    computed: {},
    created() {
        this.loadTimeSettings();
    },
};
</script>

<style scoped>
.singleNumCardMd {
    text-align: center;
    height: auto;
    margin: 6px 6px 0px 6px;
}
</style>



// WEBPACK FOOTER //
// src/view/dashboard/TrendingAnalyze.vue